import { Component } from '@angular/core';

@Component({
  selector: 'app-cards9-examples-58',
  templateUrl: './cards9-examples-58.component.html'
})
export class Cards9Examples58Component {}
